<script setup>
import { computed } from 'vue';
import { asset } from '../helpers.js';

const imgTrikot = asset('/hkcm/images/trikot.png', 'public');

const props = defineProps({
    totalEndPriceGross: { type: Number, required: true },
    differencePrice: { type: Number, required: true },
    minOrderValue: { type: Number, required: true }
});

const isEligible = computed(() => props.totalEndPriceGross >= props.minOrderValue);

const progress = computed(() =>
    Math.min(100, Math.round((props.totalEndPriceGross / props.minOrderValue) * 100))
);

const toCurrency = (v) =>
    typeof window !== 'undefined' && window?.Intl
        ? new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(v)
        : `${v.toFixed(2)} €`;
</script>

<template>
    <!-- Produktseiten-Banner (Gewinnspiel / WM Aktion 26) -->
    <!-- TODO: Finale Marketing-Texte/CTA noch eintragen (Platzhalter). -->
    <div class="relative flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between rounded-3xl text-white p-5 sm:p-8 md:p-10">
        <div class="flex items-center gap-4">
            <img :src="imgTrikot" alt="Trikot" class="h-16 w-16 sm:h-20 sm:w-20 shrink-0 object-contain" />
            <div class="flex flex-col gap-1">
                <h2 class="font-bold text-xl sm:text-2xl leading-tight">Gewinnspiel zur Fußball WM 2026</h2>
                <p class="text-sm sm:text-base text-white/80">
                    Gewinnspielteilnahme ab <strong>{{ toCurrency(minOrderValue) }}</strong>
                </p>
                <p class="text-sm sm:text-base font-semibold">
                    <span v-if="isEligible">Teilnahme gesichert!</span>
                    <span v-else>Noch {{ toCurrency(differencePrice) }} bis zur Teilnahme!</span>
                </p>
            </div>
        </div>

        <div class="flex flex-col gap-3 w-full sm:max-w-[320px]">
            <!-- Progress -->
            <div>
                <div class="flex justify-between text-xs text-white/70 mb-1.5">
                    <span>Fortschritt</span>
                    <span>{{ progress }}%</span>
                </div>
                <div class="h-[10px] w-full rounded-full overflow-hidden bg-white/15">
                    <div
                        class="h-full rounded-full transition-all duration-300 bg-[#006CFF]"
                        :style="{ width: progress + '%' }"
                    ></div>
                </div>
            </div>

            <a
                href="/produkte"
                class="inline-flex items-center justify-center rounded-full px-6 py-3 bg-[#006CFF] text-white text-sm font-semibold hover:brightness-110 transition"
            >
                Jetzt teilnehmen
            </a>
        </div>
    </div>
</template>
